import React, { useEffect } from 'react';
import './Disclaimer.css';

function Disclaimer() {
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <div className="container my-5">
      <h2 className="body-font-bold mb-4 fs-3">Disclaimer</h2>
      <p className="mb-4">
        The information provided on <strong>PENTADECO.IN</strong> is for general informational purposes only. 
        While we make every effort to ensure that the information on this website is accurate and up to date, 
        we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, 
        reliability, suitability, or availability with respect to the website or the products, services, or related 
        graphics contained on the website for any purpose. Any reliance you place on such information is strictly at your own risk.
      </p>

      <div className="content">
        <ol className="m-0">
          <li className="mb-4">
            <p className="fs-5 body-font-medium">Product Representation</p>
            <p className="text-muted">
              All product images, descriptions, and specifications are provided for illustrative purposes only. 
              Actual colors, sizes, and finishes may vary slightly due to photography lighting or device display settings.
            </p>
          </li>

          <li className="mb-4">
            <p className="fs-5 body-font-medium">Limitation of Liability</p>
            <p className="text-muted">
              Under no circumstances shall <strong>PENTADECO</strong>, its owners, employees, or affiliates be held liable 
              for any loss or damage, including without limitation indirect or consequential loss or damage, 
              arising from the use of this website or products purchased from it.
            </p>
          </li>

          <li className="mb-4">
            <p className="fs-5 body-font-medium">External Links</p>
            <p className="text-muted">
              This website may contain links to other websites that are not under the control of <strong>PENTADECO</strong>. 
              We have no control over the nature, content, and availability of those sites, and the inclusion of 
              any links does not necessarily imply a recommendation or endorsement of the views expressed within them.
            </p>
          </li>

          <li className="mb-4">
            <p className="fs-5 body-font-medium">No Professional Advice</p>
            <p className="text-muted">
              Any guidance or advice provided on this website, whether relating to product use, care, or otherwise, 
              is for informational purposes only and should not be considered as professional advice. 
              Customers are advised to use their discretion or consult a professional where necessary.
            </p>
          </li>

          <li className="mb-4">
            <p className="fs-5 body-font-medium">Changes to Disclaimer</p>
            <p className="text-muted">
              <strong>PENTADECO</strong> reserves the right to modify, update, or replace this disclaimer at any time 
              without prior notice. Customers are encouraged to review this page periodically.
            </p>
          </li>

          <li className="mb-4">
            <p className="fs-5 body-font-medium">Contact Information</p>
            <p className="text-muted">
              If you have any questions regarding this Disclaimer, please contact us:
            </p>
            <p className="mb-0">PENTADECO Customer Care</p>
            <p className="mb-0">
              Email:{" "}
              <a href="mailto:pentadeco@gmail.com" className="nav-link d-inline text-primary">
                pentadeco@gmail.com
              </a>
            </p>
            <p className="mb-0">
              WhatsApp:{" "}
              <a href="tel:+917738494171" className="nav-link d-inline text-primary">+91 7738494171</a> |{" "}
              <a href="tel:+918433551012" className="nav-link d-inline text-primary">+91 8433551012</a> |{" "}
              <a href="tel:+919273158535" className="nav-link d-inline text-primary">+91 9273158535</a>
            </p>
          </li>
        </ol>
      </div>
    </div>
  );
}

export default Disclaimer;
